import React from 'react';

import { noop } from 'ui-components/default-props/noop';

import { ProviderTypes } from './constants';
import { CuiProviderSettings } from './provider-settings';
import { useApiCodeFromAccountId } from './hooks/use-api-code-from-account-id';

type FreightProviderSettingsProps = {
  sellerFreightProviderId: number | string;
  onSave?: () => void;
  onError?: (error?: unknown) => void;
  onCancel?: () => void;
  onUpdateSellerData?: () => void;
};

export const FreightProviderSettings = ({
  sellerFreightProviderId,
  onSave = noop,
  onError = noop,
  onCancel = noop,
  onUpdateSellerData = noop,
}: FreightProviderSettingsProps) => {
  const providerApiCode = useApiCodeFromAccountId(sellerFreightProviderId, ProviderTypes.freight);

  if (!providerApiCode) {
    return null;
  }

  return (
    <CuiProviderSettings
      accountId={String(sellerFreightProviderId)}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      onUpdateSellerData={onUpdateSellerData}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.freight}
    />
  );
};
